/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../routes/__root'
import { Route as IndexRouteImport } from './../../routes/index'
import { Route as CalendarRouteImport } from './../../routes/calendar'
import { Route as DashboardRouteImport } from './../../routes/dashboard'
import { Route as EmailUnverifiedRouteImport } from './../../routes/email-unverified'
import { Route as RecordingRouteImport } from './../../routes/recording'
import { Route as SettingsRouteImport } from './../../routes/settings'
import { Route as SignUpRouteImport } from './../../routes/sign-up'
import { Route as TrialExpiredRouteImport } from './../../routes/trial-expired'
import { Route as SettingsIndexRouteImport } from './../../routes/settings/index'
import { Route as SettingsBillingDocumentsRouteImport } from './../../routes/settings/billing-documents'
import { Route as SettingsBillingSettingsRouteImport } from './../../routes/settings/billing-settings'
import { Route as SettingsNotesRouteImport } from './../../routes/settings/notes'
import { Route as SettingsOnlinePaymentsRouteImport } from './../../routes/settings/online-payments'
import { Route as SettingsPlanBillingRouteImport } from './../../routes/settings/plan-billing'
import { Route as SettingsPracticeDetailsRouteImport } from './../../routes/settings/practice-details'
import { Route as SettingsProfileRouteImport } from './../../routes/settings/profile'
import { Route as SettingsSecurityRouteImport } from './../../routes/settings/security'
import { Route as SettingsServicesRouteImport } from './../../routes/settings/services'
import { Route as SettingsTelehealthRouteImport } from './../../routes/settings/telehealth'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailUnverifiedRoute = EmailUnverifiedRouteImport.update({
  id: '/email-unverified',
  path: '/email-unverified',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingRoute = RecordingRouteImport.update({
  id: '/recording',
  path: '/recording',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const TrialExpiredRoute = TrialExpiredRouteImport.update({
  id: '/trial-expired',
  path: '/trial-expired',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBillingDocumentsRoute =
  SettingsBillingDocumentsRouteImport.update({
    id: '/billing-documents',
    path: '/billing-documents',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsBillingSettingsRoute = SettingsBillingSettingsRouteImport.update({
  id: '/billing-settings',
  path: '/billing-settings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsNotesRoute = SettingsNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsOnlinePaymentsRoute = SettingsOnlinePaymentsRouteImport.update({
  id: '/online-payments',
  path: '/online-payments',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPlanBillingRoute = SettingsPlanBillingRouteImport.update({
  id: '/plan-billing',
  path: '/plan-billing',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPracticeDetailsRoute = SettingsPracticeDetailsRouteImport.update({
  id: '/practice-details',
  path: '/practice-details',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsServicesRoute = SettingsServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsTelehealthRoute = SettingsTelehealthRouteImport.update({
  id: '/telehealth',
  path: '/telehealth',
  getParentRoute: () => SettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/dashboard': typeof DashboardRoute
  '/email-unverified': typeof EmailUnverifiedRoute
  '/recording': typeof RecordingRoute
  '/settings': typeof SettingsRouteWithChildren
  '/sign-up': typeof SignUpRoute
  '/trial-expired': typeof TrialExpiredRoute
  '/settings/billing-documents': typeof SettingsBillingDocumentsRoute
  '/settings/billing-settings': typeof SettingsBillingSettingsRoute
  '/settings/notes': typeof SettingsNotesRoute
  '/settings/online-payments': typeof SettingsOnlinePaymentsRoute
  '/settings/plan-billing': typeof SettingsPlanBillingRoute
  '/settings/practice-details': typeof SettingsPracticeDetailsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/services': typeof SettingsServicesRoute
  '/settings/telehealth': typeof SettingsTelehealthRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/dashboard': typeof DashboardRoute
  '/email-unverified': typeof EmailUnverifiedRoute
  '/recording': typeof RecordingRoute
  '/sign-up': typeof SignUpRoute
  '/trial-expired': typeof TrialExpiredRoute
  '/settings/billing-documents': typeof SettingsBillingDocumentsRoute
  '/settings/billing-settings': typeof SettingsBillingSettingsRoute
  '/settings/notes': typeof SettingsNotesRoute
  '/settings/online-payments': typeof SettingsOnlinePaymentsRoute
  '/settings/plan-billing': typeof SettingsPlanBillingRoute
  '/settings/practice-details': typeof SettingsPracticeDetailsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/services': typeof SettingsServicesRoute
  '/settings/telehealth': typeof SettingsTelehealthRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/dashboard': typeof DashboardRoute
  '/email-unverified': typeof EmailUnverifiedRoute
  '/recording': typeof RecordingRoute
  '/settings': typeof SettingsRouteWithChildren
  '/sign-up': typeof SignUpRoute
  '/trial-expired': typeof TrialExpiredRoute
  '/settings/billing-documents': typeof SettingsBillingDocumentsRoute
  '/settings/billing-settings': typeof SettingsBillingSettingsRoute
  '/settings/notes': typeof SettingsNotesRoute
  '/settings/online-payments': typeof SettingsOnlinePaymentsRoute
  '/settings/plan-billing': typeof SettingsPlanBillingRoute
  '/settings/practice-details': typeof SettingsPracticeDetailsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/services': typeof SettingsServicesRoute
  '/settings/telehealth': typeof SettingsTelehealthRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/calendar'
    | '/dashboard'
    | '/email-unverified'
    | '/recording'
    | '/settings'
    | '/sign-up'
    | '/trial-expired'
    | '/settings/billing-documents'
    | '/settings/billing-settings'
    | '/settings/notes'
    | '/settings/online-payments'
    | '/settings/plan-billing'
    | '/settings/practice-details'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/services'
    | '/settings/telehealth'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calendar'
    | '/dashboard'
    | '/email-unverified'
    | '/recording'
    | '/sign-up'
    | '/trial-expired'
    | '/settings/billing-documents'
    | '/settings/billing-settings'
    | '/settings/notes'
    | '/settings/online-payments'
    | '/settings/plan-billing'
    | '/settings/practice-details'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/services'
    | '/settings/telehealth'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/calendar'
    | '/dashboard'
    | '/email-unverified'
    | '/recording'
    | '/settings'
    | '/sign-up'
    | '/trial-expired'
    | '/settings/billing-documents'
    | '/settings/billing-settings'
    | '/settings/notes'
    | '/settings/online-payments'
    | '/settings/plan-billing'
    | '/settings/practice-details'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/services'
    | '/settings/telehealth'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CalendarRoute: typeof CalendarRoute
  DashboardRoute: typeof DashboardRoute
  EmailUnverifiedRoute: typeof EmailUnverifiedRoute
  RecordingRoute: typeof RecordingRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  SignUpRoute: typeof SignUpRoute
  TrialExpiredRoute: typeof TrialExpiredRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-unverified': {
      id: '/email-unverified'
      path: '/email-unverified'
      fullPath: '/email-unverified'
      preLoaderRoute: typeof EmailUnverifiedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recording': {
      id: '/recording'
      path: '/recording'
      fullPath: '/recording'
      preLoaderRoute: typeof RecordingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trial-expired': {
      id: '/trial-expired'
      path: '/trial-expired'
      fullPath: '/trial-expired'
      preLoaderRoute: typeof TrialExpiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/billing-documents': {
      id: '/settings/billing-documents'
      path: '/billing-documents'
      fullPath: '/settings/billing-documents'
      preLoaderRoute: typeof SettingsBillingDocumentsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/billing-settings': {
      id: '/settings/billing-settings'
      path: '/billing-settings'
      fullPath: '/settings/billing-settings'
      preLoaderRoute: typeof SettingsBillingSettingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/notes': {
      id: '/settings/notes'
      path: '/notes'
      fullPath: '/settings/notes'
      preLoaderRoute: typeof SettingsNotesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/online-payments': {
      id: '/settings/online-payments'
      path: '/online-payments'
      fullPath: '/settings/online-payments'
      preLoaderRoute: typeof SettingsOnlinePaymentsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/plan-billing': {
      id: '/settings/plan-billing'
      path: '/plan-billing'
      fullPath: '/settings/plan-billing'
      preLoaderRoute: typeof SettingsPlanBillingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/practice-details': {
      id: '/settings/practice-details'
      path: '/practice-details'
      fullPath: '/settings/practice-details'
      preLoaderRoute: typeof SettingsPracticeDetailsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/security': {
      id: '/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof SettingsSecurityRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/services': {
      id: '/settings/services'
      path: '/services'
      fullPath: '/settings/services'
      preLoaderRoute: typeof SettingsServicesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/telehealth': {
      id: '/settings/telehealth'
      path: '/telehealth'
      fullPath: '/settings/telehealth'
      preLoaderRoute: typeof SettingsTelehealthRouteImport
      parentRoute: typeof SettingsRoute
    }
  }
}

interface SettingsRouteChildren {
  SettingsBillingDocumentsRoute: typeof SettingsBillingDocumentsRoute
  SettingsBillingSettingsRoute: typeof SettingsBillingSettingsRoute
  SettingsNotesRoute: typeof SettingsNotesRoute
  SettingsOnlinePaymentsRoute: typeof SettingsOnlinePaymentsRoute
  SettingsPlanBillingRoute: typeof SettingsPlanBillingRoute
  SettingsPracticeDetailsRoute: typeof SettingsPracticeDetailsRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsSecurityRoute: typeof SettingsSecurityRoute
  SettingsServicesRoute: typeof SettingsServicesRoute
  SettingsTelehealthRoute: typeof SettingsTelehealthRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsBillingDocumentsRoute: SettingsBillingDocumentsRoute,
  SettingsBillingSettingsRoute: SettingsBillingSettingsRoute,
  SettingsNotesRoute: SettingsNotesRoute,
  SettingsOnlinePaymentsRoute: SettingsOnlinePaymentsRoute,
  SettingsPlanBillingRoute: SettingsPlanBillingRoute,
  SettingsPracticeDetailsRoute: SettingsPracticeDetailsRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsSecurityRoute: SettingsSecurityRoute,
  SettingsServicesRoute: SettingsServicesRoute,
  SettingsTelehealthRoute: SettingsTelehealthRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CalendarRoute: CalendarRoute,
  DashboardRoute: DashboardRoute,
  EmailUnverifiedRoute: EmailUnverifiedRoute,
  RecordingRoute: RecordingRoute,
  SettingsRoute: SettingsRouteWithChildren,
  SignUpRoute: SignUpRoute,
  TrialExpiredRoute: TrialExpiredRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
